export const MAIN_DRAWER_ID = 'main-drawer';
export const DICTIONARY_KEY = 'ACTIVE_HEADER_MENU';
export const SEARCH_FOLDER = 'SEARCH';
export const AUCTION_FOLDER = 'AUCTION';
export const NEWS_FOLDER = 'NEWS';
export const MARKETPLACE_FOLDER = 'MARKETPLACE';
export const BEHIND_THE_SCENES_FOLDER = 'BEHIND_THE_SCENES';

export const DISPLAY_HEADER_MENU = 'DISPLAY_HEADER_MENU';
